var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-message"},[_c('lx-icon',{staticClass:"info-icon",attrs:{"icon":"info","size":"24"}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }